import React  from "react";
import { useTranslation } from "src/context/Translations/context";
import { RCCGrid, RCCSwitch } from "react-common-components";
import Audit from "src/components/Audit";
import Permissions from "src/components/Permissions";
import Title from "src/components/Title";
import { IFormAnalysisModel } from "./interface";
import FormStandardsFields from "./formStandardsFields";

const FormAnalysisModel: React.FC<IFormAnalysisModel> = ({
	disabled,
	isAdd,
	data,
	register,
	unregister,
	control,
	error,
	clearErrors,
	watch,
	setValue,
	onChangeAnalysisModel
}) => {
	const { translate } = useTranslation();

	return (
		<RCCGrid
			container	
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid 
				container
				item
				xs={12}
				sm={10}
				alignItems="center"
				justify="flex-end"
			>
				<Audit data={data} type="pop"/>
			</RCCGrid>
			
			<FormStandardsFields 
				isDisabled={disabled}
				isAdd={isAdd}
				data={data}
				register={register}
				unregister={unregister}
				control={control}
				error={error}
				watch={watch}
				setValue={setValue}
				onChangeAnalysisModel={onChangeAnalysisModel}
			/>

			<RCCGrid
				container
				item
				xs={12}
				sm={10}
			>
				<RCCSwitch styleInline="margin: 10px 10px"
					name="maa001Ativo" 
					label={translate("Ativo")} 
					register={register} 
					defaultChecked={data?.maa001Ativo === "S" || true}
					disabled={disabled}
				/>
			</RCCGrid>

			<RCCGrid 
				container
				item
				xs={12}
				sm={10}
				alignItems="center"
				justify="flex-start"
				styleInline="margin-top: 20px !important"
			>
				<Title color="purple" size="sm" >
					{translate("Permissões")}
				</Title>

				<hr/>
				
				<Permissions
					disabled={disabled}
					register={register}
					unregister={unregister}
					control={control}
					error={error}
					clearErrors={clearErrors}
					permissionsNames= {{
						nameObject: "matba006",
						nameOfID: "maa006Id",
						nameOfSelectUser: "maa006Efa005Id",
						nameOfSelectGroup: "maa006Efa004Id",
						nameOfSelectPermission: "maa006Permissao",
						nameOfSelectGroupDescription: "maa006Efa004Nome",
						nameOfSelectUserDescription: "maa006Efa005Nome",
						defaultValue: data.matba006
					}}
					permissionType="simple"
				/>
			</RCCGrid>
		</RCCGrid>
	);
};

export default FormAnalysisModel;
